import React, { useState, useEffect, useCallback } from 'react';
import ProjectBox from './ProjectBox';
import { fetchAllImpactStories } from '../../Data/ProjectsData';

function ProjectsContainer(props) {
    const [allImpactStories, setAllImpactStories] = useState([]);
    const [displayStories, setDisplayStories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    
    // Pagination settings
    const storiesPerPage = props.storiesPerPage || 8; // Default 8 stories per page

    // Function to change page
    const changePage = useCallback((pageNumber) => {
        setCurrentPage(pageNumber);
    }, []);

    // Expose changePage function to parent component
    useEffect(() => {
        if (props.onPageChange) {
            props.onPageChange(changePage);
        }
    }, [props.onPageChange, changePage]);

    useEffect(() => {
        const loadImpactStories = async () => {
            try {
                setLoading(true);
                console.log('Loading impact stories...'); // Debug log
                
                const stories = await fetchAllImpactStories();
                console.log('Fetched stories:', stories); // Debug log
                
                if (stories && stories.length > 0) {
                    setAllImpactStories(stories);
                    
                    // If numberOfStories is specified, limit the total stories
                    let limitedStories = stories;
                    if (props.numberOfStories != null) {
                        limitedStories = stories.slice(0, props.numberOfStories);
                    }
                    
                    // Apply pagination
                    const startIndex = (currentPage - 1) * storiesPerPage;
                    const endIndex = startIndex + storiesPerPage;
                    const paginatedStories = limitedStories.slice(startIndex, endIndex);
                    
                    console.log('Display stories:', paginatedStories); // Debug log
                    setDisplayStories(paginatedStories);
                    
                    // Notify parent component about pagination info
                    if (props.onPaginationChange) {
                        const totalPages = Math.ceil(limitedStories.length / storiesPerPage);
                        props.onPaginationChange({
                            currentPage,
                            totalPages,
                            totalStories: limitedStories.length,
                            hasMore: currentPage < totalPages
                        });
                    }
                } else {
                    console.log('No stories found or empty array'); // Debug log
                    setAllImpactStories([]);
                    setDisplayStories([]);
                }
            } catch (err) {
                console.error('Error loading impact stories:', err);
                setError(err.message);
                setAllImpactStories([]);
                setDisplayStories([]);
            } finally {
                setLoading(false);
            }
        };

        loadImpactStories();
    }, [props.numberOfStories, currentPage, storiesPerPage]); // Removed props.onPaginationChange from dependencies

    if (loading) {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <div className="loading-spinner">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading impact stories...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <p>Error loading impact stories: {error}</p>
                    <p>Please try again later.</p>
                </div>
            </div>
        );
    }

    if (displayStories.length === 0) {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <p>No impact stories available at the moment.</p>
                    <p>Debug: Check console for more information.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="project-list project-list-1">
            {displayStories.map((story, index) => (
                <ProjectBox
                    key={story.id || index}
                    heading={story.heading}
                    description={story.description}
                    image={story.image}
                    alt={story.alt}
                    slug={story.slug}
                    type={props.type}
                />
            ))}
            {props.load && displayStories.length > 0 && (
                <div className="load-more-container text-center mt-4">
                    <button className="btn btn-primary" onClick={() => changePage(currentPage + 1)}>
                        Load More Stories
                    </button>
                </div>
            )}
        </div>
    );
}

export default ProjectsContainer; 